import { action } from 'typesafe-actions';
import { AgendamentosTypes, IAgendamentos, IFilter, IFitroAgendamentos, Pagination } from './types';

export const loadRequest = (
  filtro: IFitroAgendamentos | any,
  parceiros: any,
  codCdd: number | undefined,
  pagination?: Pagination,
  sorter?: any
) => action(AgendamentosTypes.LOAD_REQUEST, { filtro, parceiros, codCdd, pagination, sorter });
export const loadSuccess = (data: IAgendamentos[], pagination: Pagination, total: {}) =>
  action(AgendamentosTypes.LOAD_SUCCESS, { data, pagination, total });
export const loadFailure = () => action(AgendamentosTypes.LOAD_FAILURE);

export const filterAgendamentos = (filter: IFilter) =>
  action(AgendamentosTypes.FILTER_AGEMDAMEMTOS, { filter });

export const sorterAgendamentos = (ordenacao: any) =>
  action(AgendamentosTypes.SORTER_AGEMDAMEMTOS, { ordenacao });

export const cleanStateAgem = () => action(AgendamentosTypes.CLEAN_AGENDAMENTOS);
